import React, { useContext, useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import VersionSideBar from "../Components/VersionSideBar";
import Config from "../config.json";
import Loading from "./Loading";
import ComponentContext from "../Context";
import Noskheh from "../Images/noskheh.png";
import Statics from "../Statics";

const title = "مشخصات نسخه‌ها";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | مشخصات نسخه‌ها",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const body =
  "اطلاعات مربوط به نسخه‌های پژوهیار ( نسخه 1، نسخه 1.5، نسخه 2،نسخه 3) برای هر یک از نسخه‌های منتشرشده در دسترس کاربران قرار می‌گیرد. مشخصات نسخه‌ها به هنگام به‌روزرسانی منتشر می‌شود.";

const Versions = () => {
  const context = useContext(ComponentContext);

  const [loadingState, setLoadingState] = useState(Statics.NOT_LOADED);
  const [changelogs, setChangelogs] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);

  const getChangelogs = () => {
    setLoadingState(Statics.LOADING);
    const storedChangelogs = sessionStorage.getItem("allChangelogs");

    if (storedChangelogs) {
      const parsedChangelogs = JSON.parse(storedChangelogs);
      setChangelogs(parsedChangelogs);
      setLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getStaticValue(
        {
          slugs: ["version_changelog"],
        },
        data => {
          setChangelogs(data.data[0].value);
          sessionStorage.setItem(
            "allChangelogs",
            JSON.stringify(data.data[0].value),
          );
          setLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };
  let lastVersion;
  let lastPublication;
  if (changelogs[0] && changelogs[0].children.length > 0) {
    lastVersion = changelogs[0].value;
    lastPublication = changelogs[0].children[0];
  } else {
    lastPublication =
      "دیتای آخرین نسخه به درستی گرفته نشد لطفا به پشتیبانی سایت اطلاع بدید";
  }

  useEffect(() => {
    if (loadingState === Statics.NOT_LOADED) {
      getChangelogs();
    }
    // eslint-disable-next-line
  }, [loadingState]);

  const handleChildSelect = child => {
    setSelectedChild(child);
  };
  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner
        image={Noskheh}
        body={body}
        title={title}
        header_color="#F2E2B1"
      />
      <Row className="p-4 p-md-5 mx-0" style={{ background: "#fff" }}>
        {loadingState === Statics.LOADING ? (
          <div className="pajoohyar-loading">
            <Loading />
          </div>
        ) : null}
        {loadingState === Statics.CAUSED_ERROR ? (
          <div className="version-error-parent">
            <p>ارتباط با سرور با مشکل مواجه شد !</p>
            <img
              className="version-error-img"
              src="images/errorPic.webp"
              width="200px"
              alt="error-png"
            />
          </div>
        ) : null}
        <Col md={3} className="mb-3 mb-md-0 p-0 pl-0 pl-md-3">
          {loadingState === Statics.LOADED ? (
            <VersionSideBar
              links={changelogs}
              sidebar_title="نسخه‌ها"
              onChildSelect={handleChildSelect}
            />
          ) : null}
        </Col>

        {loadingState === Statics.LOADED ? (
          <Col md={9}>
            <Row className="container-content-with-sidebar">
              <Col>
                {loadingState === Statics.LOADED && selectedChild ? (
                  <div>
                    <h5 className="version-title">
                      {selectedChild.parentLink.value}
                      {" > "}
                      {selectedChild.title}
                    </h5>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: selectedChild.body,
                      }}
                      className="version-item-content text-justify card-body"
                    />{" "}
                  </div>
                ) : null}
                {loadingState === Statics.LOADED && !selectedChild ? (
                  <div>
                    <h5 className="version-title">
                      {lastVersion}
                      {" > "}
                      {lastPublication.title}
                    </h5>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: lastPublication.body,
                      }}
                      className="version-item-content text-justify card-body"
                    />
                  </div>
                ) : null}
              </Col>
            </Row>
          </Col>
        ) : null}
      </Row>
    </DocumentMeta>
  );
};

export default Versions;
